function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTodayIconFilled = function SvgTodayIconFilled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M1.685 11.717a.92.92 0 0 1 0-1.302L10.15 1.95l1.302 1.302 5.144 5.144 2.018 2.019a.92.92 0 0 1-1.302 1.302l-.716-.716v6.603h-5.525v-2.762a.92.92 0 1 0-1.842 0v2.762H3.704V11l-.717.717a.92.92 0 0 1-1.302 0",
    clipRule: "evenodd"
  }));
};
export default SvgTodayIconFilled;